export default __webpack_public_path__ + "static/media/istqb.7c656a4c.pdf";